import {useCallback, useEffect} from 'react';
import {useAppStore} from '../../store';
import {ContactInterface} from '../../models';
import {toast} from 'react-hot-toast';
import {LoadingOverlay, Container} from '@mantine/core';

function ContactList() {
  const {contactStore} = useAppStore();

  const {loading, error, contacts} = contactStore.getters;
  //const [data, setData] = useState([]);

  const getMessages = useCallback(async () => {
    await contactStore.actions.loadContacts();
    if (error) {
      toast.error(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getMessages();
  }, [getMessages]);

  return (
    <>
      {loading ? (
        <LoadingOverlay
          loaderProps={{size: 'sm', color: 'green', variant: 'dots'}}
          overlayOpacity={0.3}
          overlayColor="#c5c5c5"
          visible
        />
      ) : (
        <div className="mt-5">
          <Container>
            {contacts?.map((contact: ContactInterface, index: number) => (
              <div className="card mt-5" key={index}>
                <div className="card-header">Email: {contact.email}</div>
                <div className="card-body">
                  <h5 className="card-title">Name: {contact.name}</h5>

                  <p className="card-text">Phone: {contact.phone}</p>

                  <p className="card-text">Message: {contact.message}</p>
                </div>
              </div>
            ))}
          </Container>
        </div>
      )}
    </>
  );
}

export default ContactList;
